import { jsx as e, jsxs as l } from "react/jsx-runtime";
function c(r) {
  return /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: "19", height: "16", ...r, children: /* @__PURE__ */ e("path", { d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" }) });
}
function d(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "15",
      height: "9",
      viewBox: "0 0 15 9",
      fill: "none",
      stroke: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M1.5 1.5L7.5 7.5L13.5 1.5",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function o(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "7",
      height: "11",
      viewBox: "0 0 7 11",
      fill: "rgb(var(--text-secondary) / 0.8)",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.306 5.49756L6.27959 1.52696C6.57347 1.23307 6.57347 0.757853 6.27959 0.467093C5.98571 0.176333 5.51051 0.176333 5.21663 0.467093L0.714683 4.96606C0.430183 5.25057 0.423933 5.70703 0.692793 6.00092L5.2135 10.5312C5.36044 10.6781 5.55427 10.75 5.74498 10.75C5.93569 10.75 6.12952 10.6781 6.27646 10.5312C6.57034 10.2373 6.57034 9.76204 6.27646 9.47128L2.306 5.49756Z"
        }
      )
    }
  );
}
function C(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "7",
      height: "11",
      viewBox: "0 0 7 11",
      fill: "rgb(var(--text-secondary) / 0.8)",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.69414 5.49755L0.720417 1.52696C0.426528 1.23307 0.426528 0.757853 0.720417 0.467093C1.01431 0.176333 1.48953 0.176333 1.78341 0.467093L6.2855 4.96605C6.57001 5.25056 6.57626 5.70702 6.30739 6.00091L1.78654 10.5311C1.6396 10.6781 1.44576 10.75 1.25504 10.75C1.06433 10.75 0.870488 10.6781 0.723538 10.5311C0.429648 10.2373 0.429648 9.76203 0.723538 9.47127L4.69414 5.49755Z"
        }
      )
    }
  );
}
function p(r) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.9039 2.72621H18.3769V1.35165C18.3769 0.59564 17.7813 0 17.0253 0C16.2693 0 15.6736 0.59564 15.6736 1.35165V2.72621H12.3518V1.35165C12.3518 0.59564 11.7561 0 11.0001 0C10.2441 0 9.64848 0.59564 9.64848 1.35165V2.72621H6.32663V1.35165C6.32663 0.59564 5.73099 0 4.97498 0C4.21897 0 3.62333 0.59564 3.62333 1.35165V2.72621H3.09642C1.46986 2.72621 0.141113 4.05495 0.141113 5.68151V18.8086C0.141113 20.4351 1.46985 21.7639 3.09642 21.7639H18.9039C20.5304 21.7639 21.8592 20.4351 21.8592 18.8086V5.68151C21.8592 4.05495 20.5304 2.72621 18.9039 2.72621H18.9039ZM18.9039 19.7937H3.0964C2.54658 19.7937 2.1113 19.3584 2.1113 18.8086V8.79719H19.889V18.8086C19.889 19.3584 19.4537 19.7937 18.9039 19.7937Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 10.767H4.53961C4.33343 10.767 4.15015 10.9502 4.15015 11.1564V12.8975C4.15015 13.1037 4.33343 13.287 4.53961 13.287H7.26582C7.472 13.287 7.65528 13.1037 7.65528 12.8975V11.1564C7.65528 10.9502 7.472 10.767 7.26582 10.767Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 10.767H9.62554C9.41936 10.767 9.23608 10.9502 9.23608 11.1564V12.8975C9.23608 13.1037 9.41936 13.287 9.62554 13.287H12.3747C12.5809 13.287 12.7641 13.1037 12.7641 12.8975V11.1564C12.7641 10.9502 12.5809 10.767 12.3747 10.767Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 10.767H14.7347C14.5285 10.767 14.3452 10.9502 14.3452 11.1564V12.8975C14.3452 13.1037 14.5285 13.287 14.7347 13.287H17.4609C17.6671 13.287 17.8504 13.1037 17.8504 12.8975V11.1564C17.8733 10.9502 17.69 10.767 17.4838 10.767H17.4838Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 15.281H4.53961C4.33343 15.281 4.15015 15.4643 4.15015 15.6705V17.4116C4.15015 17.6178 4.33343 17.801 4.53961 17.801H7.26582C7.472 17.801 7.65528 17.6178 7.65528 17.4116V15.6705C7.65528 15.4643 7.472 15.281 7.26582 15.281Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 15.281H9.62554C9.41936 15.281 9.23608 15.4643 9.23608 15.6705V17.4116C9.23608 17.6178 9.41936 17.801 9.62554 17.801H12.3747C12.5809 17.801 12.7641 17.6178 12.7641 17.4116V15.6705C12.7641 15.4643 12.5809 15.281 12.3747 15.281Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 15.281H14.7347C14.5285 15.281 14.3452 15.4643 14.3452 15.6705V17.4116C14.3452 17.6178 14.5285 17.801 14.7347 17.801H17.4609C17.6671 17.801 17.8504 17.6178 17.8504 17.4116V15.6705C17.8733 15.4643 17.69 15.281 17.4838 15.281H17.4838Z"
          }
        )
      ]
    }
  );
}
function s(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "13",
      height: "10",
      viewBox: "0 0 13 10",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--background-secondary))",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.39016 9.4496L0.189285 5.24872C-0.063095 4.99635 -0.063095 4.58713 0.189285 4.33472L1.10326 3.42073C1.35564 3.16832 1.76487 3.16832 2.01725 3.42073L4.84717 6.25063L10.9085 0.189285C11.1609 -0.063095 11.5701 -0.063095 11.8225 0.189285L12.7365 1.10327C12.9889 1.35565 12.9889 1.76487 12.7365 2.01727L5.30415 9.44963C5.05174 9.70201 4.64254 9.70201 4.39016 9.4496Z"
        }
      )
    }
  );
}
function t(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
        }
      )
    }
  );
}
function n(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "13",
      viewBox: "0 0 16 13",
      fill: "none",
      stroke: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M0.999756 7.84424L4.99976 11.8442L14.9998 1.84424",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function g(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.1719 0C4.92404 0 0.671875 4.25216 0.671875 9.5C0.671875 14.7478 4.92404 19 10.1719 19C15.4197 19 19.6719 14.7478 19.6719 9.5C19.6719 4.25216 15.4197 0 10.1719 0ZM12.5788 12.9392L10.1719 10.5322L7.7649 12.9392C7.48173 13.2224 7.01586 13.2224 6.7327 12.9392C6.5911 12.7976 6.51803 12.6103 6.51803 12.4231C6.51803 12.2358 6.59111 12.0486 6.7327 11.907L9.13966 9.5L6.7327 7.09303C6.5911 6.95144 6.51803 6.76418 6.51803 6.57692C6.51803 6.38966 6.59111 6.2024 6.7327 6.06081C7.01586 5.77764 7.48173 5.77764 7.7649 6.06081L10.1719 8.46778L12.5788 6.06081C12.862 5.77764 13.3279 5.77764 13.6111 6.06081C13.8942 6.34398 13.8942 6.80985 13.6111 7.09302L11.2041 9.49999L13.6111 11.907C13.8942 12.1901 13.8942 12.656 13.6111 12.9392C13.3279 13.2269 12.862 13.2269 12.5788 12.9392V12.9392Z"
        }
      )
    }
  );
}
function v(r) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "18",
      height: "4",
      viewBox: "0 0 18 4",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ e("circle", { cx: "2.50928", cy: "2.03174", r: "1.90771" }),
        /* @__PURE__ */ e("circle", { cx: "9.06396", cy: "2.03174", r: "1.90771" }),
        /* @__PURE__ */ e("circle", { cx: "15.6187", cy: "2.03174", r: "1.90771" })
      ]
    }
  );
}
function w(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4388 7.42975C9.94619 7.92232 9.14741 7.92232 8.65484 7.42975C8.16227 6.93718 8.16227 6.1384 8.65484 5.64583L12.223 2.0775C14.1937 0.106979 17.3883 0.106979 19.3589 2.0775C21.3294 4.04818 21.3294 7.24282 19.3589 9.21342L15.7909 12.7814C15.2983 13.274 14.4996 13.274 14.007 12.7814C13.5143 12.2888 13.5143 11.4901 14.007 10.9973L17.575 7.4295C18.5602 6.44416 18.5602 4.84668 17.575 3.8615C16.5897 2.87616 14.9922 2.87616 14.007 3.8615L10.4388 7.42975ZM10.4391 14.5653C10.9316 14.0727 11.7304 14.0727 12.223 14.5653C12.7157 15.058 12.7157 15.8566 12.223 16.3493L8.65483 19.9175C6.68431 21.888 3.48951 21.888 1.51891 19.9175C-0.451614 17.947 -0.451614 14.7522 1.51891 12.7816L5.0869 9.21359C5.57964 8.72102 6.37825 8.72102 6.87099 9.21359C7.36356 9.70632 7.36356 10.5051 6.87099 10.9977L3.30298 14.5657C2.31764 15.5508 2.31764 17.1483 3.30298 18.1337C4.28816 19.1189 5.88565 19.1189 6.87099 18.1337L10.4391 14.5653ZM14.0071 7.42934C14.4996 7.92191 14.4996 8.72069 14.0071 9.21326L8.65483 14.5651C8.16226 15.0578 7.36348 15.0578 6.87091 14.5651C6.37834 14.0725 6.37834 13.2737 6.87091 12.7812L12.2227 7.42934C12.7155 6.93661 13.5141 6.93661 14.0068 7.42934H14.0071Z"
        }
      )
    }
  );
}
function h(r) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8813 9.18766C10.687 9.54872 10.3116 9.77547 9.90164 9.77949C9.49164 9.7835 9.11193 9.56414 8.91059 9.20696C8.70926 8.84978 8.71819 8.41134 8.93391 8.06266C9.69772 6.73986 11.2548 6.09497 12.7302 6.49031C14.2056 6.88566 15.2316 8.22267 15.2317 9.75016C15.2317 10.9854 14.4745 11.9934 13.5442 12.5627C12.7972 13.0194 13.2629 14.2502 11.8533 14.2502C11.5347 14.25 11.2311 14.1147 11.0179 13.8779C10.8047 13.6411 10.7019 13.325 10.735 13.0082C10.7654 12.413 11.0309 11.9282 11.32 11.5772C11.6249 11.2059 12.0265 10.9022 12.3325 10.7199C14.0392 9.70516 11.9579 7.62953 10.8813 9.18878V9.18766ZM11.8533 15.3752C11.232 15.3752 10.7283 15.8788 10.7283 16.5002C10.7283 17.1215 11.232 17.6252 11.8533 17.6252C12.4746 17.6252 12.9783 17.1215 12.9783 16.5002C12.9783 15.8788 12.4746 15.3752 11.8533 15.3752Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function L(r) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 17 16",
      fill: "none",
      stroke: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2107 7.17079C14.2107 10.5788 11.448 13.3416 8.03993 13.3416C4.6319 13.3416 1.86914 10.5788 1.86914 7.17079C1.86914 3.76276 4.6319 1 8.03993 1C11.448 1 14.2107 3.76276 14.2107 7.17079Z",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M15.7538 14.8847L12.3984 11.5293",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
var i = /* @__PURE__ */ ((r) => (r.stripe_card = "stripe:card", r.stripe_ideal = "stripe:ideal", r.stripe_bancontact = "stripe:bancontact", r.stripe_applepay = "stripe:applepay", r.stripe_klarna = "stripe:klarna", r.dlocal_card = "dlocal:card", r.dlocal_boleto = "dlocal:boleto", r.dlocal_pix = "dlocal:pix", r.paypal_soap = "paypal-soap", r.paypal_rest = "paypal-rest", r.mercadopago_br_card = "mercadopago-br:card", r.mercadopago_br_pix = "mercadopago-br:pix", r.mercadopago_br_boleto = "mercadopago-br:boleto", r.mercadopago_co_card = "mercadopago-co:card", r.mercadopago_ar_card = "mercadopago-ar:card", r.mercadopago_mx_card = "mercadopago-mx:card", r.mercadopago_cl_card = "mercadopago-cl:card", r.razorpay = "razorpay", r.flutterwave = "flutterwave", r.mollie = "mollie", r.gocardless = "gocardless", r.cash_on_delivery = "cash-on-delivery", r.xendit_id_card = "xendit-id:card", r.xendit_ph_card = "xendit-ph:card", r.paystack_gh_card = "paystack-gh:card", r.paystack_ke_card = "paystack-ke:card", r.paystack_ng_card = "paystack-ng:card", r.paystack_za_card = "paystack-za:card", r.paystack_eg_card = "paystack-eg:card", r.paystack_ci_card = "paystack-ci:card", r.secure_and_pay = "secure-and-pay", r))(i || {});
export {
  d as A,
  c as C,
  v as D,
  w as L,
  i as P,
  h as Q,
  L as S,
  s as a,
  g as b,
  t as c,
  n as d,
  p as e,
  o as f,
  C as g
};
